export const environment = {
  production: false,
  // urlBackend: 'http://localhost:3000/api',
  urlBackend: 'https://bsistem.munilongavi.cl/api',
  urlImages: 'https://bsistem.munilongavi.cl',
  appVersion: '1.3.1',
};
